const urlHead = "https://demoback.dakafacai.com/"
//const urlHead = "http://127.0.0.1:8000/"
export default urlHead
